//import { Tooltip, Toast, Popover } from 'bootstrap';
///global.jQuery = require('jquery');
///global.$ = global.jQuery;
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
//global.bootstrap = require('bootstrap');
//global.moment = require( 'moment' );
//global.jszip = require('jszip');
//global.date_picker = require('zebra_datepicker');
require('bootstrap');
import moment from "moment";
window.moment = moment;
//import 'moment/locale/en.js';
import * as jszip from "jszip";
window.jszip = jszip;
import * as Zebra_DatePicker from 'zebra_datepicker';
window.Zebra_DatePicker = Zebra_DatePicker;
require('@popperjs/core');
require('./layout.css');
require('./datatables.js');
require('bootstrap/dist/css/bootstrap.css');
require('@fortawesome/fontawesome-free/css/all.min.css');
// Datatables Bootstrap 5 styles
require('datatables.net-bs5/css/dataTables.bootstrap5.css');
require('datatables.net-buttons-dt/css/buttons.dataTables.css');
require('datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css');
require('zebra_datepicker/dist/css/bootstrap/zebra_datepicker.css');
// … or you can import only a specific set of icons:
// require('@fortawesome/fontawesome-free/css/fontawesome.css');
// require('@fortawesome/fontawesome-free/css/v4-shims.css');
// require('@fortawesome/fontawesome-free/css/regular.css');
// require('@fortawesome/fontawesome-free/css/solid.css');
// require('@fortawesome/fontawesome-free/css/brands.css');
// global.Swal = require('sweetalert2');
// Swal for Bootstrap 5:
// global.sweetalert2 = require('sweetalert2');
// global.Swal = global.sweetalert2.mixin({
//     // Fix for Bootstrap 5
//     scrollbarPadding: false,
//     heightAuto: false,
// });
// Swal.fire(
//     'Good job!',
//     'You clicked the button!',
//     'success'
//     );
//global.Vue = require('vue');
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').then(registration => {
        console.log('SW registered: ', registration);
      }).catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
    });
  }
  